import React from 'react'
import { useGameStore } from '../store/gameStore'
import './MainMenu.css'

function MainMenu() {
  const { user, setCurrentPage, logout } = useGameStore()

  const menuItems = [
    {
      id: 'game-hub',
      title: 'Game Hub',
      description: 'Start battles, manage teams',
      icon: '⚔️'
    },
    {
      id: 'card-library',
      title: 'Card Library',
      description: 'View and draw cards',
      icon: '🎴'
    },
    {
      id: 'team-builder',
      title: 'Team Builder',
      description: 'Organize your teams',
      icon: '👥'
    }
  ]

  return (
    <div className="main-menu">
      <div className="menu-header">
        <h1>Welcome, {user?.username}!</h1>
        <div className="player-stats">
          <div className="stat">
            <span className="label">Level</span>
            <span className="value">{user?.level || 1}</span>
          </div>
          <div className="stat">
            <span className="label">EXP</span>
            <span className="value">{user?.exp || 0}</span>
          </div>
          <div className="stat">
            <span className="label">Coins</span>
            <span className="value">{user?.coins || 0}</span>
          </div>
          <div className="stat">
            <span className="label">Energy</span>
            <span className="value">{user?.energy || 0}/{user?.max_energy || 100}</span>
          </div>
        </div>
      </div>

      <div className="menu-content">
        <div className="menu-grid">
          {menuItems.map((item) => (
            <div
              key={item.id}
              className="menu-item"
              onClick={() => setCurrentPage(item.id)}
            >
              <div className="item-icon">{item.icon}</div>
              <h3>{item.title}</h3>
              <p>{item.description}</p>
            </div>
          ))}
        </div>

        <div className="menu-footer">
          <button className="btn-logout" onClick={logout}>
            Logout
          </button>
        </div>
      </div>
    </div>
  )
}

export default MainMenu
